import { __rest } from 'tslib';
import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';
import { cleanObject } from '@teko/utils';
import i18next from 'i18next';
import { getProductUrl } from '@teko/discovery';

const ORDER_TAB_WAIT_PAYMENT = 0;
const ORDER_TAB_WAIT_CONFIRM = 1;
const ORDER_TAB_WAIT_DELIVER = 1;
const ORDER_TAB_PROCESSING = 1;
const ORDER_TAB_DELIVERED = 2;
const ORDER_TAB_CANCELED = 2;
const ORDER_TAB_DONE = 2;
const ORDER_STATE_DELIVERED = 'DELIVERED';
const ORDER_CUSTOMER_STATE_WAITING_DELIVERY = 1;
const ORDER_CUSTOMER_STATE_DELIVERING = 2;
const STAFF_ORDER_STATUS_PROCESSING = 'PROCESSING';
const STAFF_ORDER_STATUS_WAIT_FOR_PROCESS = 'WAIT_FOR_PROCESS';
const STAFF_ORDER_STATUS_PAID = 'PAID';
const STAFF_ORDER_STATES = {
    new: 'Đơn mới tạo',
    active: 'Chờ thanh toán',
    paid: 'Đã thanh toán',
    processing: 'Đang xử lý',
    cancelled: 'Đã hủy',
    delivered: 'Đã giao hàng',
    returned: 'Đã trả hàng',
    reverted: 'Đã trả hàng',
};
const STATUS_COLOR = {
    waiting: '',
    processing: '#f78212',
    success: '#53c305',
    canceled: '#d60f29',
};
const CONSUMER_ORDER_STATUSES = [
    {
        status: 'DRAFT',
        text: null,
        displayStatus: null,
        tab: null,
        color: '',
    },
    {
        status: 'WAITING_FOR_APPROVAL',
        text: 'Chờ duyệt',
        displayStatus: 'Chờ duyệt',
        tab: null,
        color: '',
    },
    {
        status: 'CREATED',
        text: null,
        displayStatus: null,
        tab: null,
        color: '',
    },
    {
        status: 'PENDING',
        text: 'Chờ xác nhận',
        displayStatus: 'Chờ xác nhận',
        tab: ORDER_TAB_WAIT_PAYMENT,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROCESSING',
        text: 'Đang xử lý',
        displayStatus: 'Đang xử lý',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_PAYMENT_CONFIRMATION',
        text: 'Chờ thanh toán',
        displayStatus: 'Chờ thanh toán',
        tab: ORDER_TAB_WAIT_PAYMENT,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PAYMENT_CONFIRMED',
        text: 'Đã thanh toán',
        displayStatus: 'Đã thanh toán',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'CANCELLED',
        text: 'Đã hủy',
        displayStatus: 'Đã hủy',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'REVERTED',
        text: 'Đã trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'RETURNED',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'REFUND',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'NEED_REFUND',
        text: 'Trả hàng',
        displayStatus: 'Đã trả hàng',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'DELIVERING',
        text: 'Đang giao hàng',
        displayStatus: 'Đang giao hàng',
        tab: ORDER_TAB_PROCESSING,
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERED',
        text: 'Hoàn thành',
        displayStatus: 'Hoàn thành',
        tab: ORDER_TAB_DONE,
        color: STATUS_COLOR.success,
    },
];
const ORDER_SHIPMENT_STATUS = [
    {
        status: 'NEW',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_MANUAL_CONFIRMATION',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROVIDER_TRANSFERRING',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PROVIDER_TRANSFERRED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAIT_FOR_PRODUCT',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'WAITING_FOR_PRODUCT',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PICKED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'PACKED',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERING',
        displayStatus: 'Đang giao',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'DELIVERED',
        displayStatus: 'Đã giao',
        color: STATUS_COLOR.success,
    },
    {
        status: 'PARTIAL_DELIVERED',
        displayStatus: 'Đang giao',
        color: STATUS_COLOR.processing,
    },
    {
        status: 'RETURNED',
        displayStatus: 'Đã trả hàng',
        color: STATUS_COLOR.success,
    },
    {
        status: 'CANCELLED',
        displayStatus: 'Đã hủy',
        color: STATUS_COLOR.canceled,
    },
    {
        status: 'PROCESSING',
        displayStatus: 'Chờ giao hàng',
        color: STATUS_COLOR.processing,
    },
];

var viLang = {
	"Đơn mới tạo": "Đơn mới tạo",
	"Chờ thanh toán": "Chờ thanh toán",
	"Đã thanh toán": "Đã thanh toán",
	"Đang xử lý": "Đang xử lý",
	"Đã hủy": "Đã hủy",
	"Đã giao hàng": "Đã giao hàng",
	"Đã trả hàng": "Đã trả hàng",
	"Chờ duyệt": "Chờ duyệt",
	"Chờ xác nhận": "Chờ xác nhận",
	"Trả hàng": "Trả hàng",
	"Đang giao hàng": "Đang giao hàng",
	"Hoàn thành": "Hoàn thành",
	"Chờ giao hàng": "Chờ giao hàng",
	"Đang giao": "Đang giao",
	"Đã giao": "Đã giao"
};

var enLang = {
	"Đơn mới tạo": "Created",
	"Chờ thanh toán": "Waiting for payment",
	"Đã thanh toán": "Payment confirmed",
	"Đang xử lý": "Processing",
	"Đã hủy": "Cancelled",
	"Đã giao hàng": "Delivered",
	"Đã trả hàng": "Returned",
	"Chờ duyệt": "Waiting for approval",
	"Chờ xác nhận": "Waiting for confirmation",
	"Trả hàng": "Returning",
	"Đang giao hàng": "Delivering",
	"Hoàn thành": "Completed",
	"Chờ giao hàng": "Waiting for delivery",
	"Đang giao": "Delivering",
	"Đã giao": "Delivered"
};

const NAMESPACE = 'order';
const t = (keys, options) => {
    return i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
};
const lang = {
    vi: viLang,
    en: enLang,
};

const getOrderStatus = (record) => {
    const status = record.computedStatus.displayStatus;
    const statusColor = record.computedStatus.color;
    return { status, statusColor };
};
const getShipmentStatus = (status, shipmentStatuses = ORDER_SHIPMENT_STATUS) => {
    return (shipmentStatuses.find((shipmentStatus) => shipmentStatus.status === status) || { color: STATUS_COLOR.processing, displayStatus: t('Chờ giao hàng') });
};
const ORDER_WAITING_PAYMENT_STATE = [
    'CREATED',
    'WAITING_FOR_PAYMENT_CONFIRMATION',
];
const getOrderCustomerState = (status) => {
    const orderDeliveringState = ['DELIVERING'];
    const orderWaitingForDeliveryState = [
        'PAID',
        'WAIT_FOR_PROCESS',
        'PROCESSING',
    ];
    if (orderDeliveringState.includes(status))
        return 2;
    if (orderWaitingForDeliveryState.includes(status))
        return 1;
    if (ORDER_WAITING_PAYMENT_STATE.includes(status))
        return 0;
    if (CONSUMER_ORDER_STATUSES.filter((orderState) => orderState.tab === ORDER_TAB_DONE)
        .map((orderState) => orderState.status)
        .includes(status))
        return 3;
    return 0;
};
const DELIVERY_SERVICE_GROUP_ID = 1;
const TECHNICAL_SUPPORT_SERVICE_ID = 5;
const SHOWROOM_SERVICE_ID = 4;
const EVOUCHER_PAYMENT_METHOD = 'PMH';
const SHIPPING_SKU = '1206838';
const TECHNICAL_SUPPORT_SKU = '1702079';
const getGifts = (product, products, promotions) => {
    const gifts = [];
    promotions.map((promotion) => {
        var _a, _b;
        if (promotion.applyType === 'product' &&
            ((_b = (_a = promotion === null || promotion === void 0 ? void 0 : promotion.applyOn) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.lineItemId) === product.lineItemId &&
            !!promotion.gifts.length) {
            promotion.gifts.map((gift) => {
                const product = products.find((product) => product.sku === gift.sku);
                product &&
                    gifts.push({
                        name: product.name,
                        price: product.price,
                        quantity: gift.quantity,
                        imageUrl: gift.image,
                    });
            });
        }
    });
    return gifts;
};
const convertItems = (product, gifts) => {
    return Object.assign(Object.assign({}, product), { imageUrl: product.imageUrl
            ? product.imageUrl
            : `/api/products/${product.sku}/default_image`, finalPrice: product.rowTotal, price: product.price, link: {
            as: getProductUrl(product.name, product.sku),
            href: { pathname: '/products/[sku]', query: { sku: product.sku } },
            passHref: true,
        }, isGift: !!gifts.length &&
            gifts.findIndex((gift) => gift.lineItemId === product.lineItemId) !==
                -1 });
};
const convertOrderDetail = (data) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { items, promotions, routerItems, serviceFee, shipments, grandTotal, discountApproval, } = data;
    const gifts = (promotions || []).reduce((total, promotion) => [...total, ...((promotion === null || promotion === void 0 ? void 0 : promotion.gifts) || [])], []);
    const orderPromotion = (promotions || []).find((promo) => promo.applyType === 'order' && !promo.coupon);
    const orderCouponPromotion = (promotions || []).find((promo) => promo.applyType === 'order' && promo.coupon);
    const subTotalOrder = items
        .filter((product) => !product.isGift)
        .reduce((subTotal, current) => {
        return subTotal + current.unitPrice * current.quantity;
    }, 0);
    const shippingFee = (serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.delivery.reduce((total, delivery) => {
        const { groupId, price } = delivery;
        return total + (groupId === DELIVERY_SERVICE_GROUP_ID ? price : 0);
    }, 0)) || 0;
    const installationFee = ((serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.optional) || []).reduce((total, delivery) => {
        const { id, price } = delivery;
        return total + (id === TECHNICAL_SUPPORT_SERVICE_ID ? price : 0);
    }, 0) || 0;
    const hasShowroomService = serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.delivery.find((service) => service.id === SHOWROOM_SERVICE_ID);
    const discount = data
        ? subTotalOrder +
            shippingFee -
            (((_b = (_a = data === null || data === void 0 ? void 0 : data.technicalSupportFee) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.price) || 0) -
            grandTotal
        : 0;
    const unitAdd = items.reduce((unitAdd, product) => {
        return unitAdd + (product.unitAdd || 0) * product.quantity;
    }, 0);
    const totalFee = shippingFee + installationFee;
    const defaultPartOrderPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.find(({ isDefault, coupon, applyType }) => isDefault && coupon && applyType === 'part_order');
    const partOrderDiscount = (defaultPartOrderPromotion === null || defaultPartOrderPromotion === void 0 ? void 0 : defaultPartOrderPromotion.discount) || 0;
    const promotionsDiscount = (promotions || []).reduce((total, promotion) => total +
        (promotion.applyType !== 'product' &&
            !(promotion.isDefault && promotion.coupon)
            ? promotion.discount
            : 0), 0);
    const comboPromotionDiscount = (promotions || []).reduce((total, promotion) => total +
        (promotion.applyType === 'combo' && !promotion.isDefault
            ? promotion.discount
            : 0), 0);
    const subTotal = grandTotal -
        totalFee -
        unitAdd +
        partOrderDiscount +
        promotionsDiscount +
        ((discountApproval === null || discountApproval === void 0 ? void 0 : discountApproval.amount) || 0) -
        comboPromotionDiscount;
    const partOrderPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.filter(({ coupon, applyType }) => coupon && applyType === 'part_order');
    const comboPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.filter(({ coupon, applyType }) => !coupon && applyType === 'combo');
    const totalShipment = shipments === null || shipments === void 0 ? void 0 : shipments.length;
    const eVoucherAmount = ((_d = (_c = data === null || data === void 0 ? void 0 : data.payments) === null || _c === void 0 ? void 0 : _c.find(({ paymentMethod }) => paymentMethod === EVOUCHER_PAYMENT_METHOD)) === null || _d === void 0 ? void 0 : _d.amount) || 0;
    const comboParentsPromotion = (promotions || []).find((promo) => promo.applyType === 'combo');
    const comboParentGifts = (comboParentsPromotion === null || comboParentsPromotion === void 0 ? void 0 : comboParentsPromotion.gifts) || [];
    const comboParentVoucher = (comboParentsPromotion === null || comboParentsPromotion === void 0 ? void 0 : comboParentsPromotion.voucher) || {};
    const nonProductPromotions = [
        ...(partOrderPromotion || []),
        ...(comboPromotion || []),
        orderPromotion,
    ].filter((promotion) => promotion &&
        !(promotion.discount &&
            !promotion.gifts.length &&
            !promotion.voucher.quantity));
    const expectedDate = (_e = data === null || data === void 0 ? void 0 : data.shippingInfo) === null || _e === void 0 ? void 0 : _e.expectedDate;
    if (expectedDate) {
        data.shippingInfo.expectedDate = new Date(expectedDate.replace(' ', 'T'));
    }
    const item2promotion = promotions.reduce((prev, curr) => {
        for (const item of curr.applyOn) {
            if (!prev.has(item.lineItemId)) {
                prev.set(item.lineItemId, []);
            }
            prev.get(item.lineItemId).push(curr);
        }
        return prev;
    }, new Map());
    const orderItems = (!!items.length &&
        items
            .filter((product) => product.sku !== SHIPPING_SKU &&
            product.sku !== TECHNICAL_SUPPORT_SKU)
            .map((product) => {
            return Object.assign(Object.assign({}, convertItems(product, gifts)), { prizes: getGifts(product, items, promotions), promotions: item2promotion.get(product.lineItemId) || [] });
        })) ||
        [];
    const convertedShipments = (_f = data.shipments) === null || _f === void 0 ? void 0 : _f.map((shipment) => (Object.assign(Object.assign({}, shipment), { routerItems: shipment.routerItems.map((routerItem) => convertItems(routerItem, gifts)) })));
    const orderDetail = Object.assign(Object.assign({}, data), { eVoucherAmount,
        totalShipment, items: orderItems, shipments: convertedShipments, routerItems: (!!(routerItems === null || routerItems === void 0 ? void 0 : routerItems.length) &&
            routerItems
                .filter((product) => product.sku !== SHIPPING_SKU &&
                product.sku !== TECHNICAL_SUPPORT_SKU)
                .map((product) => {
                return Object.assign(Object.assign({}, convertItems(Object.assign(Object.assign({}, product), { imageUrl: items.find((item) => item.sku === product.sku).imageUrl ||
                        product.imageUrl, price: product.price > -1
                        ? product.price
                        : items.find((item) => item.lineItemId === product.lineItemId).price }), gifts)), { prizes: [] });
            })) ||
            [], shippingFee, technicalSupportFee: installationFee, totalFee, orderDiscount: promotionsDiscount - comboPromotionDiscount, defaultPartOrderPromotion,
        partOrderPromotion,
        comboPromotion,
        hasShowroomService,
        orderPromotion,
        partOrderDiscount,
        orderCouponPromotion,
        discount,
        subTotalOrder,
        subTotal,
        unitAdd,
        comboParentGifts,
        comboParentVoucher, nonProductPromotions: nonProductPromotions.map((promo) => {
            return Object.assign(Object.assign({}, promo), { gifts: promo.gifts.map((item) => {
                    const product = orderItems.find((product) => product.sku === item.sku);
                    return Object.assign(Object.assign({}, item), { imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || '' });
                }) });
        }), get totalItems() {
            return orderItems.reduce((total, item) => total + item.quantity - item.cancelledQuantity, 0);
        },
        get customerState() {
            return getOrderCustomerState(data.status);
        }, totalPriceDifference: ((_g = orderItems === null || orderItems === void 0 ? void 0 : orderItems.map((item) => ((item === null || item === void 0 ? void 0 : item.unitAdd) || 0) * ((item === null || item === void 0 ? void 0 : item.quantity) || 0))) === null || _g === void 0 ? void 0 : _g.reduce((prevValue, currentValue) => currentValue + prevValue, 0)) || 0 });
    return orderDetail;
};

const cookOrder = (data, orderStatuses = CONSUMER_ORDER_STATUSES) => {
    var _a, _b, _c, _d, _e;
    return Object.assign(Object.assign({}, data), { promotions: (_a = data === null || data === void 0 ? void 0 : data.promotions) === null || _a === void 0 ? void 0 : _a.map((_a) => {
            var { gifts } = _a, rest = __rest(_a, ["gifts"]);
            return (Object.assign({ gifts: gifts || [] }, rest));
        }), computedStatus: orderStatuses.find((item) => item.status === data.status), predictCancelAt: data.predictCancelAt
            ? new Date(/((\+\d{2}:\d{2})|Z)$/.test(data.predictCancelAt)
                ? data.predictCancelAt
                : `${data.predictCancelAt}Z`)
            : undefined, paymentMethod: (_c = (_b = data === null || data === void 0 ? void 0 : data.payments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.paymentMethod, createdAt: new Date(/((\+\d{2}:\d{2})|Z)$/.test(data.createdAt)
            ? data.createdAt
            : `${data.createdAt}Z`), shippingInfo: Object.assign({}, data.shippingInfo), shippingFee: ((_e = (_d = data === null || data === void 0 ? void 0 : data.payments) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.totalPaid) || 0 });
};
const cookMyOrders = (data, orderStatuses = CONSUMER_ORDER_STATUSES) => {
    return Object.assign(Object.assign({}, data), { records: data.data.map((record) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return Object.assign(Object.assign({}, record), { promotions: (_a = record === null || record === void 0 ? void 0 : record.promotions) === null || _a === void 0 ? void 0 : _a.map((_a) => {
                    var { gifts } = _a, rest = __rest(_a, ["gifts"]);
                    return (Object.assign({ gifts: gifts || [] }, rest));
                }), computedStatus: orderStatuses.find((item) => item.status === record.status), predictCancelAt: record.predictCancelAt
                    ? new Date(/((\+\d{2}:\d{2})|Z)$/.test(record.predictCancelAt)
                        ? record.predictCancelAt
                        : `${record.predictCancelAt}Z`)
                    : undefined, paymentMethod: (_c = (_b = record === null || record === void 0 ? void 0 : record.payments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.paymentMethod, createdAt: new Date(/((\+\d{2}:\d{2})|Z)$/.test(record.createdAt)
                    ? record.createdAt
                    : `${record.createdAt}Z`), shippingInfo: Object.assign(Object.assign({}, record.shippingInfo), { expectedDate: new Date((_d = record === null || record === void 0 ? void 0 : record.shippingInfo) === null || _d === void 0 ? void 0 : _d.expectedDate) }), shippingFee: ((_g = (_f = (_e = record === null || record === void 0 ? void 0 : record.serviceFee) === null || _e === void 0 ? void 0 : _e.delivery) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.rowTotal) || 0 });
        }) });
};
const cookOrdersWithDiscovery = async (data, terminalCode, orderStatuses, discoveryService) => {
    if (data.data.length) {
        const allItemSkus = [];
        data.data.forEach((record) => {
            record.items.forEach((item) => allItemSkus.push(item.sku));
        });
        const products = await discoveryService.getProductDetailBySkus({
            skus: allItemSkus.join(),
            terminalCode,
        });
        const dataWithItemImage = Object.assign(Object.assign({}, data), { records: data.data.map((record) => {
                var _a, _b;
                const sellerIdsInOrder = Array.from(new Set(record.items.map((item) => item.sellerId)));
                const productsOfSeller = products.filter((product) => product.productInfo.seller.id === sellerIdsInOrder[0]);
                const seller = (_b = (_a = productsOfSeller === null || productsOfSeller === void 0 ? void 0 : productsOfSeller[0]) === null || _a === void 0 ? void 0 : _a.productInfo) === null || _b === void 0 ? void 0 : _b.seller;
                return Object.assign(Object.assign({}, record), { seller: seller ? [seller] : [], items: record.items.map((item) => {
                        var _a;
                        const product = products.find((p) => p.productInfo.sku === item.sku);
                        return Object.assign(Object.assign({}, item), { product, imageUrl: ((_a = product === null || product === void 0 ? void 0 : product.productInfo) === null || _a === void 0 ? void 0 : _a.imageInfo) || '' });
                    }) });
            }) });
        return cookMyOrders(dataWithItemImage, orderStatuses);
    }
    return cookMyOrders(data, orderStatuses);
};
class OrderService {
    constructor(orderApiUrl) {
        this.fetchOrderDetail = async (orderId, customerId) => {
            const { data } = await this.orderApi.get(`api/v1/orders/${orderId}?customerProfileId=${customerId}`);
            return data;
        };
        this.getOrder = async ({ orderId, customerId, }) => {
            const res = await this.fetchOrderDetail(orderId, customerId);
            return res.data;
        };
        this.getOrderDetail = async ({ orderId, terminalCode, discoveryService, customerId, orderStatuses, }) => {
            var _a;
            const data = await this.fetchOrderDetail(orderId, customerId);
            if ((_a = data.data.items) === null || _a === void 0 ? void 0 : _a.length) {
                const allItemSkus = [];
                data.data.items.forEach((item) => allItemSkus.push(item.sku));
                const products = await discoveryService.getProductDetailBySkus({
                    skus: allItemSkus,
                    terminalCode,
                });
                const sellers = Array.from(new Set(products.map((product) => { var _a, _b; return (_b = (_a = product === null || product === void 0 ? void 0 : product.productInfo) === null || _a === void 0 ? void 0 : _a.seller) === null || _b === void 0 ? void 0 : _b.id; })));
                const dataWithItemImage = Object.assign(Object.assign({}, data.data), { sellers: sellers.map((id) => {
                        var _a;
                        return (_a = products.find((product) => { var _a, _b; return ((_b = (_a = product === null || product === void 0 ? void 0 : product.productInfo) === null || _a === void 0 ? void 0 : _a.seller) === null || _b === void 0 ? void 0 : _b.id) === id; })) === null || _a === void 0 ? void 0 : _a.productInfo.seller;
                    }), items: data.data.items.map((item) => {
                        var _a;
                        const product = products.find((product) => product.productInfo.sku == item.sku);
                        return Object.assign(Object.assign({}, item), { imageUrl: ((_a = product === null || product === void 0 ? void 0 : product.productInfo) === null || _a === void 0 ? void 0 : _a.imageUrl) || '' });
                    }) });
                const cookedOrder = cookOrder(dataWithItemImage, orderStatuses);
                return convertOrderDetail(Object.assign(Object.assign({}, cookedOrder), { computedStatus: cookedOrder.computedStatus || {
                        displayStatus: cookedOrder.displayStatus,
                        color: cookedOrder.displayStatusColor,
                    } }));
            }
            return convertOrderDetail(data);
        };
        this.getOrders = async ({ statuses, terminalCode, discoveryService, offset = 0, limit = 10, orderStatuses, customerId, sort = '-createdAt', }) => {
            const getOrdersParams = new URLSearchParams(cleanObject({
                status,
                limit,
                customerProfileId: customerId,
                offset,
                sort,
            }));
            const getOrdersParamsStatuses = statuses ||
                CONSUMER_ORDER_STATUSES.map((orderStatus) => orderStatus.status);
            getOrdersParamsStatuses.forEach((status) => getOrdersParams.append('status', status));
            const res = await this.orderApi.get(`api/v1/orders?${getOrdersParams.toString()}`);
            if (res && res.data && !res.error) {
                return cookOrdersWithDiscovery(res.data, terminalCode, orderStatuses, discoveryService);
            }
        };
        this.importOrder = async (orderId) => {
            const url = `/api/v1/import-order?orderId=${orderId}`;
            const { data } = await this.orderApi.get(url);
            return data;
        };
        this.updateVatInfo = async (orderId, vatInfo) => {
            const url = `/api/v1/orders/${orderId}/vat-info`;
            const { data } = await this.orderApi.put(url, vatInfo);
            return data;
        };
        this.orderApi = new Api(orderApiUrl);
        this.orderApi.addInterceptor(accessTokenInterceptor);
    }
}
class StaffOrderService extends OrderService {
    constructor() {
        super(...arguments);
        this.fetchOrderDetail = async (orderId) => {
            const { data } = await this.orderApi.get(`/api/v1/marketplace/orders/${orderId}`);
            return data;
        };
        this.updateShipmentStatus = async (shipmentStatus) => {
            const { data } = await this.orderApi.patch('/api/v1/seller/orders/status', {
                data: [shipmentStatus],
            });
            return data;
        };
        this.updateSellerOrderStatus = async (requestData) => {
            const { data } = await this.orderApi.patch('/api/v1/seller/orders/status', {
                data: requestData,
            });
            return data;
        };
        this.cancelShipment = async (shipments) => {
            await this.orderApi.post('/api/v1/shipments/cancel', {
                shipments: shipments,
            });
        };
        this.returnRequest = async (returnRequest) => {
            const { data } = await this.orderApi.post('/api/v2/return-requests', {
                data: returnRequest,
            });
            return data;
        };
        this.updateOrderAtStore = async (orderId) => {
            const { data } = await this.orderApi.post(`/api/v1/orders/${orderId}/update-at-store`, {});
            return data;
        };
        this.stockRequest = async (params) => {
            const data = await this.orderApi.post('/api/v1/stock_requests', params);
            return data;
        };
        this.updateVatInfo = async (orderId, vatInfo) => {
            const url = `/api/v1/orders/${orderId}/vat-info`;
            const { data } = await this.orderApi.put(url, vatInfo);
            return data;
        };
    }
}

export { CONSUMER_ORDER_STATUSES, NAMESPACE, ORDER_CUSTOMER_STATE_DELIVERING, ORDER_CUSTOMER_STATE_WAITING_DELIVERY, ORDER_SHIPMENT_STATUS, ORDER_STATE_DELIVERED, ORDER_TAB_CANCELED, ORDER_TAB_DELIVERED, ORDER_TAB_DONE, ORDER_TAB_PROCESSING, ORDER_TAB_WAIT_CONFIRM, ORDER_TAB_WAIT_DELIVER, ORDER_TAB_WAIT_PAYMENT, OrderService, STAFF_ORDER_STATES, STAFF_ORDER_STATUS_PAID, STAFF_ORDER_STATUS_PROCESSING, STAFF_ORDER_STATUS_WAIT_FOR_PROCESS, STATUS_COLOR, StaffOrderService, getOrderCustomerState, getOrderStatus, getShipmentStatus, lang };
